<form [formGroup]="gateOutForm">
    <p-card>
        <div class="col-12 md:col-12">
            <div class="p-fluid">
                <h4>Receiving Detail</h4>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Gate Entry No</strong></label>

                        <p-dropdown [options]="gate_in_unloading_list" optionLabel="name" optionValue="name"
                            [filter]="true" filterBy="name" [showClear]="true" placeholder="Select a Gate Entry No"
                            formControlName="gate_entry_no" (onChange)="onTokenNoSelected($event.value)">
                            <ng-template pTemplate="selectedItem" let-selectedOption>
                                <div class="flex align-items-center gap-2">
                                    {{ selectedOption?.name }}
                                </div>
                            </ng-template>
                            <ng-template let-token pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    {{ token?.name }}
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <!-- <div class="field col">
                        <label>Purpose<span class="required-asterisk">*</span></label>
                        <input pInputText  [disabled]="true" />
                    </div>
                    <div class="field col">
                        <label>Plant<span class="required-asterisk">*</span></label>
                        <input pInputText  />
                    </div>
                    <div class="field col">
                        <label>Gate<span class="required-asterisk">*</span></label>
                        <input pInputText  />
                    </div> -->
                    <div class="field col">
                    </div>
                    <div class="field col">
                    </div>
                </div>
            </div>
        </div>
    </p-card> <br>
    <p-card>
        <!-- <p-accordion>
            <p-accordionTab header="Gate Details"> -->
        <div class="p-fluid">
            <fieldset class="section gate-info">
                <legend><strong> Gate Details</strong></legend>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Remark 1</strong></label>
                        <input pInputText formControlName="remark_1" id="remark_1" />
                    </div>
                    <div class="field col">
                        <label><strong> Remark 2</strong></label>
                        <input pInputText formControlName="remark_2" id="remark_2" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Invoice/ Challan No </strong></label>
                        <input pInputText formControlName="invoice">
                    </div>
                    <div class="field col">
                        <label><strong> Invoice Date</strong></label>
                        <p-calendar formControlName="invoice_date" [iconDisplay]="'input'" [showIcon]="true"
                            dateFormat="dd/mm/yy" [showButtonBar]="true"></p-calendar>
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Transpoter Name</strong></label>
                        <input pInputText />
                    </div>
                    <div class="field col">
                        <label><strong> Driver Name </strong></label>
                        <input pInputText formControlName="driver" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Driver Mobile No </strong></label>
                        <input pInputText formControlName="driver_mobile_no" />
                    </div>
                    <div class="field col">
                        <label><strong> Docket No </strong></label>
                        <input pInputText formControlName="docket_no" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Docket Date</strong></label>
                        <p-calendar formControlName="docket_date" [iconDisplay]="'input'" [showIcon]="true"
                            dateFormat="dd/mm/yy" [showButtonBar]="true"></p-calendar>
                    </div>
                    <div class="field col">
                        <label for="gateNumber"><strong> Gate No </strong></label>
                        <input id="gateNumber" type="text" pInputText formControlName="gate_number">
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Vehicle</strong></label>
                        <input pInputText formControlName="vehicle" />
                    </div>
                    <div class="field col">
                        <label><strong> Plant </strong></label>
                        <input pInputText formControlName="plant" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Gate</strong></label>
                        <input pInputText formControlName="gate" />
                    </div>
                    <div class="field col">
                        <label><strong>Purpose</strong> </label>
                        <input pInputText formControlName="purpose" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Number Of Packages</strong></label>
                        <input pInputText formControlName="number_of_packages" />
                    </div>
                    <div class="field col">
                        <label><strong> Net Weight</strong></label>
                        <input pInputText formControlName="total_net_weight" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Gross Weight</strong></label>
                        <input pInputText formControlName="total_gross_weight" />
                    </div>

                    <div class="field col">
                        <label><strong> Unloading Point</strong></label>
                        <input pInputText formControlName="loading_unloading_point">
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> BOE No</strong></label>
                        <input pInputText formControlName="boe_no" />
                    </div>
                    <div class="field col">
                        <label><strong> BOE Date </strong></label>
                        <p-calendar formControlName="boe_date" [iconDisplay]="'input'" [showIcon]="true"
                            dateFormat="dd/mm/yy" [showButtonBar]="true"></p-calendar>
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> E Way Bill No</strong></label>
                        <input pInputText formControlName="e_way_bill_no">
                    </div>
                    <div class="field col">
                        <label><strong> Total Invoice Value</strong></label>
                        <input pInputText formControlName="total_invoice_value" />

                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Origin Of Country</strong></label>
                        <input pInputText formControlName="origin_of_country" />
                    </div>
                    <div class="field col">
                        <label><strong> Created By</strong></label>
                        <input pInputText formControlName="created_by" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Created On </strong></label>
                        <input pInputText formControlName="created_on" />
                    </div>
                    <div class="field col">
                        <label><strong> Received By</strong></label>
                        <input pInputText formControlName="received_by" />
                    </div>
                </div>
            </fieldset>

        </div>
        <!-- </p-accordionTab>
        </p-accordion> -->
        <div *ngIf="showAccordion">
            <p-accordion *ngIf="poDetails.controls.length > 0">
                <div formArrayName="poDetails">
                    <p-accordionTab [header]="'Purchase Order ' + (i + 1)" class="record-details"
                        *ngFor="let group of poDetails.controls; let i = index" [formGroupName]="i">
                        <div class="details-container">
                            <fieldset class="section po-details">
                                <legend><strong>PO Details</strong></legend>
                                <div class="p-fluid details-form">
                                    <div class="p-formgroup-inline">
                                        <div class="p-field flex-column mt-3">
                                            <label for="agNumber"><strong> PO/Agreement Number</strong></label>
                                            <input id="agNumber" type="text" pInputText
                                                formControlName="poagreement_no">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Company Code</strong></label>
                                            <input pInputText formControlName="company_code">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Company Name</strong></label>
                                            <input pInputText formControlName="company_name">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Doc. Cat</strong></label>
                                            <input pInputText formControlName="doc_cat" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Plant Code</strong></label>
                                            <input pInputText formControlName="plant_code" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Plant Name</strong></label>
                                            <input pInputText formControlName="plant_name" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Vendor Code</strong></label>
                                            <input pInputText formControlName="vendor_code" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Vendor Name </strong></label>
                                            <input pInputText formControlName="vendor_name" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Purchase Type </strong></label>
                                            <input pInputText />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label> <strong> Document Type</strong></label>
                                            <input pInputText formControlName="doc_type" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <fieldset class="section item-details" *ngIf="recordDetails.poAccordions.length > 0">
                            <legend><strong>Item Details</strong></legend>
                            <p-table [value]="recordDetails.poAccordions[i].items">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>PO No</th>
                                        <th>Item No</th>
                                        <th>Material Code</th>
                                        <th>Material Description</th>
                                        <th>PO Qty</th>
                                        <th>Received Qty</th>
                                        <th>UoM</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>{{item.poNumber}}</td>
                                        <td>{{item.itemNo}}</td>
                                        <td>{{item.materialCode}}</td>
                                        <td>{{item.materialDescription}}</td>
                                        <td>{{item.poQty}}</td>
                                        <td>{{item.receivedQty}}</td>
                                        <td>{{item.uom}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </fieldset>

                    </p-accordionTab>
                </div>
            </p-accordion>
        </div>
        <div style="text-align: center;">
            <p-button label="Submit" (click)="onSubmit()"></p-button>
        </div>
    </p-card>
</form>

<!-- <div style="margin-top: 70px;"></div> -->

<p-toast></p-toast>